/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import Grid from "@mui/material/Grid";
import wizardStyle from "../wizardStyle";
import { Checkbox } from "@mui/material";
import React from "react";
import { FormDataTypes } from "../../../types/FormDataTypes";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

type MissingDocumentCheckboxProps = {
  updateValues: FormDataTypes["updateValue"];
  documentType: string;
  values: FormDataTypes["values"];
  product: AbstractCase;
  onChange: (documentType: string) => void;
};

export const MissingDocumentCheckbox = ({ product, values, documentType, updateValues, onChange }: MissingDocumentCheckboxProps) => {
  const isMissingDocument = values?.missingDocuments?.includes(documentType);

  return (
    <>
      <Grid sx={wizardStyle.hintHeader} size={12}>
        <strong>Falls Ihnen (gerade) keine Unterlagen vorliegen:</strong>
      </Grid>
      <Grid
        sx={wizardStyle.checkbox}
        size={{
          xs: 2,
          sm: 1
        }}>
        <Checkbox name={documentType} checked={isMissingDocument ?? false} onChange={() => onChange(documentType)} />
      </Grid>
      <Grid
        sx={!isMissingDocument ? wizardStyle.warningText : undefined}
        size={{
          xs: 10,
          sm: 11
        }}>
        Ich versichere, dass mir dieses Dokument nicht vorliegt. Mir ist bewusst, dass daher eine Prüfung und Bearbeitung meines Falls gegebenenfalls nicht
        möglich ist.
      </Grid>
    </>
  );
};
